export type Environment = 'LOCAL' | 'DEVELOPMENT' | 'PRODUCTION';

const getEnvVar = (keys: string[], fallback?: string): string | undefined => {
  for (const key of keys) {
    const val = (process.env as any)[key];
    if (val) return val;
  }
  return fallback;
};

export const getBaseUrl = (): string => {
  const base = getEnvVar(['REACT_APP_ROUTE_URL_BASE', 'VITE_ROUTE_URL_BASE'], '');
  return base || '';
};

export const getEnvironment = (): Environment | undefined => {
  const env = getEnvVar(['REACT_APP_ENVIRONMENT', 'VITE_ENVIRONMENT']);
  if (!env) return undefined;
  const upper = env.toUpperCase();
  if (['LOCAL', 'DEVELOPMENT', 'PRODUCTION'].includes(upper)) {
    return upper as Environment;
  }
  return undefined;
};